module.exports = __webpack_public_path__ + "static/img/Steven.Amendola.3fbbdcd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Steven.Amendola.jpg
// module id = eFKq
// module chunks = 0